// src/BirthdayWebsite.js
import React, { useState, useEffect, useRef } from 'react';
import './BirthdayWebsite.css';

// --- IMPORTS FOR 28 PHOTOS ---
// Ensure these files exist in src/assets/
import photo1 from './assets/photo1.jpg';
import photo2 from './assets/photo2.jpg';
import photo3 from './assets/photo3.jpg';
import photo4 from './assets/photo4.jpg';
import photo5 from './assets/photo5.jpg';
import photo6 from './assets/photo6.jpg';
import photo7 from './assets/photo7.jpg';
import photo8 from './assets/photo8.jpg';
import photo9 from './assets/photo9.jpg';
import photo10 from './assets/photo10.jpg';
import photo11 from './assets/photo11.jpg';
import photo12 from './assets/photo12.jpg';
import photo13 from './assets/photo13.jpg';
import photo14 from './assets/photo14.jpg';
import photo15 from './assets/photo15.jpg';
import photo16 from './assets/photo16.jpg';
import photo17 from './assets/photo17.jpg';
import photo18 from './assets/photo18.jpg';
import photo19 from './assets/photo19.jpg';
import photo20 from './assets/photo20.jpg';
import photo21 from './assets/photo21.jpg';
import photo22 from './assets/photo22.jpg';
import photo23 from './assets/photo23.jpg';
import photo24 from './assets/photo24.jpg';
import photo25 from './assets/photo25.jpg';
import photo26 from './assets/photo26.jpg';

import birthdayMusic from './assets/birthday_song.mp3';

const images = [
  photo1, photo2, photo3, photo4, photo5, photo6, photo7, 
  photo8, photo9, photo10, photo11, photo12, photo13, photo14,
  photo15, photo16, photo17, photo18, photo19, photo20, photo21,
  photo22, photo23, photo24, photo25, photo26
];

const greetings = [
  "Happy Birthday, my love! ❤️",              
  "To the woman who stole my heart.",         
  "Your smile lights up my world.",           
  "Every day with you is a new adventure.",   
  "Remembering our beautiful moments...",     
  "You are my best friend.",                  
  "Cheers to another year of us! 🥂",            
  "You are beautiful, inside and out.",       
  "My favorite place is next to you.",        
  "I love the way you laugh.",                          
  "To many more sunsets together.",           
  "You make life so much sweeter. 🎂",           
  "My constant source of joy.",               
  "Growing old with you is my dream.",        
  "You are my sunshine on rainy days.",       
  "I admire your strength and grace.",        
  "Simply the best thing in my life.",        
  "Here's to your dreams coming true.",       
  "I love you more than words can say.",      
  "You deserve the world today. 🌍",             
  "Forever grateful for your love.",          
  "You are my safe haven.",                   
  "Celebrating the queen of my heart. 👑",    
  "My heart beats only for you.",                                     
  "The best is yet to come.",                 
  "I love you, forever and always."           
];

const BirthdayWebsite = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const audioRef = useRef(null);
  const [showWebsite, setShowWebsite] = useState(false);

  const totalImages = images.length;

  // Helper to calculate wrapped indices for 3D effect
  const getCorrectIndex = (index) => {
    return (index % totalImages + totalImages) % totalImages;
  };

  useEffect(() => {
    if (showWebsite) {
      const timer = setInterval(() => {
        setActiveIndex((prevIndex) => (prevIndex + 1) % totalImages);
      }, 4000); // Changes every 4 seconds

      if (audioRef.current) {
        audioRef.current.play().catch(e => console.log("Audio play failed:", e));
        audioRef.current.volume = 0.5;
      }

      return () => {
        clearInterval(timer);
        if (audioRef.current) audioRef.current.pause();
      };
    }
  }, [showWebsite, totalImages]);

  const handleStartClick = () => setShowWebsite(true);

  if (!showWebsite) {
    return (
      <div className="start-screen">
        {/* A preview balloon on start screen */}
        <div className="css-balloon" style={{position:'relative', bottom:'unset', animation:'none', marginBottom:'40px', transform: 'scale(1.2)'}}>
             <span className="balloon-shine"></span>
        </div>
        <h1>A Birthday Surprise!</h1>
        <p>Are you ready?</p>
        <button onClick={handleStartClick} className="start-btn">Click to Begin ❤️</button>
      </div>
    );
  }

  return (
    <div className="birthday-container">
      <audio ref={audioRef} src={birthdayMusic} loop />

      {/* 1. GLORIOUS VIBRANT BALLOONS */}
      {[...Array(15)].map((_, i) => (
        <div 
          key={`bal-${i}`}
          className="css-balloon"
          style={{
            left: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 5}s`,
            animationDuration: `${15 + Math.random() * 10}s`
          }}
        >
          {/* The Shine Effect inside the balloon */}
          <span className="balloon-shine"></span>
        </div>
      ))}

      {/* 2. CONFETTI PARTICLES */}
      {[...Array(40)].map((_, i) => (
        <div 
          key={`conf-${i}`} 
          className="confetti" 
          style={{
            left: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 5}s`,
            backgroundColor: ['#FFC700', '#FF0000', '#2E3192', '#41BBC7', '#FF69B4'][Math.floor(Math.random() * 5)]
          }}
        ></div>
      ))}

      {/* 3. 3D CAROUSEL */}
      <div className="carousel-container">
        {images.map((image, index) => {
          let positionClass = 'hidden';
          if (index === activeIndex) {
            positionClass = 'center';
          } else if (index === getCorrectIndex(activeIndex - 1)) {
            positionClass = 'left';
          } else if (index === getCorrectIndex(activeIndex + 1)) {
            positionClass = 'right';
          }

          return (
            <div key={index} className={`photo-card ${positionClass}`}>
              <img src={image} alt={`memory-${index}`} className="photo" />
            </div>
          );
        })}
      </div>

      {/* 4. GREETING TEXT */}
      <div className="greeting-area">
        <p key={activeIndex} className="greeting-text fade-in-text">
          {greetings[activeIndex]}
        </p>
      </div>

    </div>
  );
};

export default BirthdayWebsite;